import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useGetGoalsByCode } from '../../../../api/coreData'
import Loading from '../../../molecules/Loading'
import FadeIn from '../../../molecules/Transitions/FadeIn'

function GoalStatus ({ status }) {
  if (status === 'green') {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: '12px', height: '12px', borderRadius: 'var(--border-radius-round)', backgroundColor: 'var(--color-success-500)' }}>&nbsp;</div>
      </div>
    )
  }

  if (status === 'yellow') {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: '12px', height: '12px', borderRadius: 'var(--border-radius-round)', backgroundColor: 'var(--color-warning-500)' }}>&nbsp;</div>
      </div>
    )
  }

  if (status === 'red') {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: '12px', height: '12px', borderRadius: 'var(--border-radius-round)', backgroundColor: 'var(--color-danger-500)' }}>&nbsp;</div>
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ width: '12px', height: '12px', borderRadius: 'var(--border-radius-round)', backgroundColor: 'var(--color-neutral-500)' }}>&nbsp;</div>
    </div>
  )
}

GoalStatus.propTypes = {
  status: PropTypes.oneOf(['green', 'yellow', 'red'])
}

function GoalList ({ goals, className, style }) {
  const goalCodes = useMemo(() => {
    return goals.map(g => g.code)
  }, [goals])
  const { data, isLoading } = useGetGoalsByCode(goalCodes)

  if (isLoading) {
    return (
      <div className={className} style={style}>
        <Loading />
      </div>
    )
  }

  return (
    <div className={className} style={style}>
      <FadeIn>
        <table>
          <tbody>
            {(goals || []).map(g => {
              const dataGoal = (data?.goals || []).find(gx => gx.code === g.code)
              if (!dataGoal) return null

              return (
                <tr key={dataGoal.goalId}>
                  <td style={{ width: '100%', padding: 'var(--padding-sm) 0' }}>{dataGoal.name}</td>
                  <td><GoalStatus status={g.status} /></td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </FadeIn>
    </div>
  )
}

GoalList.propTypes = {
  goals: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string,
    status: PropTypes.oneOf(['red', 'yellow', 'green'])
  })),
  className: PropTypes.string,
  style: PropTypes.object
}

export default GoalList
